module.exports = __webpack_public_path__ + "img/auctions.0012a007.svg";